import script from "./ProcessDesigner.vue?vue&type=script&setup=true&lang=js"
export * from "./ProcessDesigner.vue?vue&type=script&setup=true&lang=js"

import "./ProcessDesigner.vue?vue&type=style&index=0&id=7c6f0523&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c6f0523"]])

export default __exports__